export default __webpack_public_path__ + "static/media/default.b0364e495512602131a9e077ce4a8721.png";